/**************************************************************************************************/
/** @import Helpers/Documents                                                                    **/
/**************************************************************************************************/
import { LegacyPDF } from '@/Helpers/Documents/LegacyPDF/LegacyPDF'
import { PDFRectangle } from '@/Helpers/Documents/LegacyPDF/GeometryPDF'

/**************************************************************************************************/
/** @internal Class @name ComponentPDF                                                           **/
/**************************************************************************************************/
class ComponentPDF
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private height: number

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor(pdf: LegacyPDF, x: number, y: number, h: number, drawSafeArea: boolean)
	{
		this.height = h

		// SafeArea.
		if (drawSafeArea)
		{
			pdf.setTempGStateProps({ opacity: 0 }, (self) =>
			{
				self.setGlobalY(x)
				new PDFRectangle(self, x, y, self.getPageWidth(), this.getHeight())
					.setIncludeHeight(false)
					.setStrokeColor('#FF00FF')
					.draw()
				;
			})
		}
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public getHeight() : number
	{
		return this.height
	}
}

/**************************************************************************************************/
/** @export Class @name HeaderPDF                                                                **/
/**************************************************************************************************/
export class HeaderPDF extends ComponentPDF
{
	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor(pdf: LegacyPDF, headerText: string, logoPath: string, drawSafeArea = false)
	{
		super(pdf, 0, 0, pdf.getDefaultHeaderHeight(), drawSafeArea)
		pdf.setFontColor('black')
		pdf.setFontSize(16)
		pdf.updateTextOption('align', 'left')
		pdf.addImage(logoPath, 0, 0, 120, this.getHeight())
		pdf.addTextCentered(headerText, 4, 0, true)
		pdf.setGlobalY(this.getHeight())
	}
}

/**************************************************************************************************/
/** @export Class @name FooterPDF                                                                **/
/**************************************************************************************************/
export class FooterPDF extends ComponentPDF
{
	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor(pdf: LegacyPDF, companyName: string, companyAddress: string)
	{
		const height = pdf.getDefaultFooterHeight()
		const footerY = pdf.getPageHeight() - height
		super(pdf, 0, footerY, height, false)

		// Comprobar si existe espacio para el Footer.
		pdf.updateAvailableHeightSpace(height)
		pdf.setGlobalY(footerY + 4)
		pdf.addText(companyName, 0, 4, 10, false)
		pdf.addTextCentered(companyAddress, 0, 10)
	}
}